export function updateOrdersDeliveryRequest (orders, deliveryRequestId, update) {
  if (Object.keys(update).length === 0) {
    return orders
  }

  return orders.map(order => {
    const deliveryRequest = order._embedded && order._embedded.deliveryRequest
    if (!deliveryRequest || `${deliveryRequest.id}` !== `${deliveryRequestId}`) {
      return order
    }

    return {
      ...order,
      _embedded: {
        ...order._embedded,
        deliveryRequest: {
          ...deliveryRequest,
          ...update
        }
      }
    }
  })
}
